<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Seçenek Ekle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn
          class="mr-3"
          type="button"
          variant="danger"
          :to="`/Products/${ProductID}`"
          :size="ButtonSize"
        >
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Geri</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(Product).length === 0">Hata!</b-alert>

    <template v-if="Object.keys(Product).length > 0">
      <b-alert show variant="danger" v-if="ExtraTypesGUI.length === 0">
        Bu ürün için sisteminizde ekli
        <strong>seçenek türü</strong> bulunamamıştır.
        <br />Seçenek eklemek için lütfen bu ürüne seçenek türü tanımlaması yapınız.
      </b-alert>

      <template v-if="ExtraTypesGUI.length > 0">
        <b-alert show variant="info">Seçenek Eklenen Ürün: {{ Product.Name }}</b-alert>

        <form @submit.prevent="AddExtra">
          <b-form-group class="formgroup" label="Seçenek Türü">
            <b-form-select v-model="Extra.TypeID" :options="ExtraTypesGUI"></b-form-select>
          </b-form-group>

          <b-form-group
            class="formgroup"
            :label="Enums[index]"
            v-for="(property, index) in ExtraGUI"
            :key="index"
          >
            <b-form-input
              :type="['Price'].indexOf(index) !== -1 ? 'number' : 'text'"
              v-model="Extra[index]"
              @keypress.enter.prevent="AddExtra"
            ></b-form-input>
          </b-form-group>

          <div class="m-t-40 d-block border-top pt-3 pl-3">
            <b-btn type="submit" variant="success" size="lg">
              <i class="material-icons mifix">save</i>
              <span class="ml-1">Ekle</span>
            </b-btn>
          </div>
        </form>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Seçenek",
        Price: "Fiyat"
      },
      Extra: {
        TypeID: 0,
        Name: "",
        Price: 0
      },
      ExtraGUI: {},
      ExtraTypesGUI: [],
      Product: {}
    };
  },
  computed: {
    ...mapState(["StoreData", "ButtonSize"]),
    ProductID() {
      return this.$route.params.ID;
    }
  },
  methods: {
    async Refresh() {
      if (this.StoreData.Products[this.ProductID]) {
        await this.$set(
          this,
          "Product",
          this.StoreData.Products[this.ProductID]
        );

        await this.$set(
          this,
          "ExtraGUI",
          Object.filterKey(this.Extra, x => ["TypeID"].indexOf(x) === -1)
        );

        let _ExtraTypes = [];

        if (this.StoreData.Products[this.ProductID])
          for (let i in this.StoreData.Products[this.ProductID].ExtraTypes) {
            const _ExtraType = this.StoreData.Products[this.ProductID]
              .ExtraTypes[i];

            _ExtraTypes.push({
              value: _ExtraType.ID,
              text: _ExtraType.Name
            });
          }

        await this.$set(this, "ExtraTypesGUI", _ExtraTypes);
      }
    },
    async AddExtra() {
      await this.$store.dispatch("AddLoading", "AddExtra");

      await Services.Nozich.Send(
        "AddExtra",
        {
          ProductID: this.ProductID,
          Extra: this.Extra
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "AddExtra");

          if (Data.Status === "Success") {
            await this.$router.push(`/Products/${this.ProductID}`);
          }
        }
      );
    }
  },
  async mounted() {
    await this.Refresh();

    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
      await this.Refresh();
    });
  }
};
</script>
